import { EventProfile } from '../models/serializable/event-profile.js';
import { SerialNumberPool } from '../models/serializable/serial-numbers/serial-number-pool.js';
import { SerialNumberStrategy } from '../models/serializable/serial-numbers/serial-number-strategy.js';
import { TemplateBasedSerialNumberPool } from '../models/serializable/serial-numbers/template-based-serial-number-pool.js';
import { PriceBasedSerialNumberPool } from '../models/serializable/serial-numbers/price-based-serial-number-pool.js';
import { BusinessModuleRef } from '../models/serializable/business-module-ref.js';
import { assertUnreachable } from './general-utility.js';

export function createSerialNumberPoolAtEventScope(event: EventProfile): SerialNumberPool | null {
  const strategy = event.serialNumberStrategy;
  switch(strategy) {
    case SerialNumberStrategy.AssignByTemplate:
      return TemplateBasedSerialNumberPool.forEvent(event);
    case SerialNumberStrategy.AssignByPrice:
      return PriceBasedSerialNumberPool.forEvent(event);
    default:
      assertUnreachable(strategy);
  }
}

export function createSerialNumberPoolAtBusinessScope(
    businessRef: BusinessModuleRef,
    shortCode: string,
    strategy: SerialNumberStrategy
): SerialNumberPool {
  switch(strategy) {
    case SerialNumberStrategy.AssignByTemplate:
      return TemplateBasedSerialNumberPool.forBusiness(businessRef, shortCode);
    case SerialNumberStrategy.AssignByPrice:
      return PriceBasedSerialNumberPool.forBusiness(businessRef, shortCode);
    default:
      assertUnreachable(strategy);
  }
}
